import Home from '@/components/Home'
import Login from '@/components/Login'
import LoginSms from '@/components/LoginSms'
// 机侧 mex
import MexCompQuestionList from '@/components/mex/MexCompQuestionList'
import MexSpeakQuestionList from '@/components/mex/MexSpeakQuestionList'
import MexBlueprintList from '@/components/mex/MexBlueprintList'
import MexSessionList from '@/components/mex/MexSessionList'
import MexPromotionList from '@/components/mex/MexPromotionList'
import MexAdviceList from '@/components/mex/MexAdviceList'
import MexFeedbackList from '@/components/mex/MexFeedbackList'
import MexItemStatsList from '@/components/mex/MexItemStatsList'
import MexScoreCohortList from '@/components/mex/MexScoreCohortList'
import MexGraySetting from '@/components/mex/MexGraySetting'
import MexTrialPaper from '@/components/mex/MexTrialPaper'
// 市场管理
import ActivityList from '@/components/market/ActivityList'
import ChannelManagement from '@/components/market/ChannelManagement'
import ChannelDealRate from '@/components/market/ChannelDealRate'
import ShareManagement from '@/components/market/ShareManagement'
import ExChangeRecordListB from '@/components/market/ExChangeRecordListB'
import ArticlePublishList from '@/components/market/ArticlePublishList'
import ChannelIncludeList from '@/components/market/ChannelIncludeList'
import AiChannelIncludeList from '@/components/market/AiChannelIncludeList'

// 代理管理
import AgentUserList from '@/components/agent/AgentUserList'
import AgentInviteList from '@/components/agent/AgentInviteList'
// crm
import AdviserPunchList from '@/components/crm/AdviserPunchList'
import MyResource from '@/components/crm/MyResource'
import DailyTransferList from '@/components/crm/DailyTransferList'
import TreasuryResource from '@/components/crm/TreasuryResource'
import DistributionList from '@/components/crm/DistributionList'
import SalesDealRate from '@/components/crm/SalesDealRate'
import FirstFollowList from '@/components/crm/FirstFollowList'
import SpellGroupList from '@/components/crm/SpellGroupList'
import PhoneRecordList from '@/components/crm/PhoneRecordList'
import DviAudioList from '@/components/crm/DviAudioList'
import CallAsrWord from '@/components/crm/CallAsrWord'
import CallScript from '@/components/crm/CallScript'

// 学生
import BookTestList from '@/components/user/BookTestList'
import UserPayList from '@/components/user/UserPayList'
import NewStudentService from '@/components/user/NewStudentService'
import UserPayDetail from '@/components/user/UserPayDetail'
import UserProvisionalList from '@/components/user/UserProvisionalList'
import UserExperienceList from '@/components/user/UserExperienceList'
import UserTrackList from '@/components/user/UserTrackList'
import StudentRiskList from '@/components/user/StudentRiskList'
import UserTrackEdit from '@/components/user/UserTrackEdit'
import ParentCommunicationRecords from '@/components/user/ParentCommunicationRecords'
import ParentCommunicationAdviserRecords from '@/components/user/ParentCommunicationAdviserRecords'
import AddOrderFailRecords from '@/components/user/AddOrderFailRecords'
import AddSendMaterialRecords from '@/components/user/AddSendMaterialRecords'
import BindingValidTimeFailRecords from '@/components/user/BindingValidTimeFailRecords'
import BookUserLeaveTimeList from '@/components/user/BookUserLeaveTimeList'
import BookCourseChangeList from '@/components/user/BookCourseChangeList'
import EditStudentInfo from '@/components/user/EditStudentInfo'
import PersonUserTrackList from '@/components/user/PersonUserTrackList'
import ActivityExamineList from '@/components/user/ActivityExamineList'
import ExchangeRecordList from '@/components/user/ExchangeRecordList'
import UserRefundList from '@/components/user/UserRefundList'
import FollowUpList from '@/components/user/FollowUpList'
import UserOverClassList from '@/components/user/UserOverClassList'
import UserLessonsStopList from '@/components/user/UserLessonsStopList'
import UserNotAllowedList from '@/components/user/UserNotAllowedList'
import ReviewClockRecordList from '@/components/user/ReviewClockRecordList'
import dailyStudy from '@/components/user/DailyStudy'
import CancelLessonRecord from '@/components/user/CancelLessonRecord'
import UserStatusAuditList from '@/components/user/UserStatusAuditList'
import ClassHourFlow from '@/components/user/ClassHourFlow'
import DistributionStudyRecord from '@/components/user/DistributionStudyRecord'
import StudentWeekStatList from '@/components/user/StudentWeekStatList'
import StudentMonthStatList from '@/components/user/StudentMonthStatList'
import WordCardList from '@/components/user/WordCardList'
import SentenceCardList from '@/components/user/SentenceCardList'
import StudentWordbookList from '@/components/user/StudentWordbookList'
import StudentWordcardEvalList from '@/components/user/StudentWordcardEvalList'
import TchRebindBoard from '@/components/user/TchRebindBoard'

// 网盘
import DiskIndex from '@/components/disk/DiskIndex'
import KbIndex from '@/components/kb/KbIndex'
import DiskShareRecords from '@/components/disk/DiskShareRecords'
import DiskShare from '@/components/disk/DiskShare'

// 老师
import TchTrainingList from '@/components/teacher/TchTrainingList'
import TchRecruitTrainStat from '@/components/teacher/TchRecruitTrainStat'
import TchRecruitDashboard from '@/components/teacher/recruit/TchRecruitDashboard'
import TchRecruitLeaderboard from '@/components/teacher/recruit/TchRecruitLeaderboard'
import TchPendingInterview from '@/components/teacher/recruit/TchPendingInterview'
import TchReservedList from '@/components/teacher/recruit/TchReservedList'
import TchRegChannelList from '@/components/teacher/TchRegChannelList'
import TchNormalList from '@/components/teacher/TchNormalList'
import TchUnauditedList from '@/components/teacher/TchUnauditedList'
import TchAuditList from '@/components/teacher/TchAuditList'
import TchFormalList from '@/components/teacher/TchFormalList'
import ForeignTchMatchCenter from '@/components/teacher/ForeignTchMatchCenter'
import TchResignFormalList from '@/components/teacher/TchResignFormalList'
import TchAnomalyList from '@/components/teacher/TchAnomalyList'
import TchFilipinoFormalList from '@/components/teacher/TchFilipinoFormalList'
import TchLeaveList from '@/components/teacher/TchLeaveList'
import TchLeaveRateList from '@/components/teacher/TchLeaveRateList'
import TchRiskWarningList from '@/components/teacher/TchRiskWarningList'
import HrWorkbenchDashboard from '@/components/hrWorkbench/HrWorkbenchDashboard'
import HrWorkbenchProbation from '@/components/hrWorkbench/HrWorkbenchProbation'
import HrWorkbenchReview from '@/components/hrWorkbench/HrWorkbenchReview'
import HrWorkbenchContract from '@/components/hrWorkbench/HrWorkbenchContract'
import HrWorkbenchFollowup from '@/components/hrWorkbench/HrWorkbenchFollowup'
import HrWorkbenchSupervise from '@/components/hrWorkbench/HrWorkbenchSupervise'
import SmartHrRoster from '@/components/smartHr/SmartHrRoster'
import SmartHrOnboarding from '@/components/smartHr/SmartHrOnboarding'
import SmartHrRegularization from '@/components/smartHr/SmartHrRegularization'
import SmartHrTransfer from '@/components/smartHr/SmartHrTransfer'
import SmartHrResignation from '@/components/smartHr/SmartHrResignation'
import SmartHrSafety from '@/components/smartHr/SmartHrSafety'
import SmartHrGrowth from '@/components/smartHr/SmartHrGrowth'
import SmartHrContract from '@/components/smartHr/SmartHrContract'
import SmartHrRetire from '@/components/smartHr/SmartHrRetire'
import SmartHrCare from '@/components/smartHr/SmartHrCare'
import TchImpactOverview from '@/components/tchImpact/TchImpactOverview'
import TchImpactChange from '@/components/tchImpact/TchImpactChange'
import TchImpactLeave from '@/components/tchImpact/TchImpactLeave'
import TchImpactStudent from '@/components/tchImpact/TchImpactStudent'
import TchImpactRisk from '@/components/tchImpact/TchImpactRisk'
import TchImpactModel from '@/components/tchImpact/TchImpactModel'
import TchSignLogList from '@/components/teacher/TchSignLogList'
import TchSignTimeList from '@/components/teacher/TchSignTimeList'
import BookLessonOpenedList from '@/components/lesson/BookLessonOpenedList'
import LiveMonitor from '@/components/lesson/LiveMonitor'
import BookLessonTempList from '@/components/lesson/BookLessonTempList'
import BookLessonFinishedList from '@/components/lesson/BookLessonFinishedList'
import BookClassinList from '@/components/lesson/BookClassinList'
import ClassFeedback from '@/components/lesson/ClassFeedback'
import TeacherManagerMessage from '@/components/teacher/TeacherManagerMessage'
import TchLearningMaterialList from '@/components/teacher/TchLearningMaterialList'
import TchOnboardingList from '@/components/teacher/TchOnboardingList'
import TchOnboardingManage from '@/components/teacher/TchOnboardingManage'
import UserCredential from '@/components/order/UserCredential'
import UserCredential2 from '@/components/order/UserCredential2'
import BonusAndDeduction from '@/components/teacher/BonusAndDeduction'
import TchRecommendList from '@/components/teacher/TchRecommendList'
import ReferrerList from '@/components/teacher/ReferrerList'
import ReferrerFeeList from '@/components/teacher/ReferrerFeeList'
import TchTrackList from '@/components/teacher/TchTrackList'
import TchWagesList from '@/components/teacher/TchWagesList'
import TchFeedbackList from '@/components/teacher/TchFeedbackList'
import TchPerformanceList from '@/components/teacher/TchPerformanceList'
import TchForeignManageData from '@/components/teacher/TchForeignManageData'
import TchTeacherRanking from '@/components/teacher/TchTeacherRanking'
import TchHrMetricsDashboard from '@/components/teacher/TchHrMetricsDashboard'
import TchFirstCheckList from '@/components/teacher/TchFirstCheckList'
import TrialLessonRequirements from '@/components/teacher/TrialLessonRequirements'

const TchOpenedExceptionList = r => require.ensure([],
  () => r(require('@/components/teacher/TchOpenedExceptionList.vue')), 'teacher')
const TchExceptionLogList = r => require.ensure([],
  () => r(require('@/components/teacher/TchExceptionLogList.vue')), 'teacher')
// 订单
import FundPackageList from '@/components/order/FundPackageList'
import PerformanceList from '@/components/order/PerformanceList'
import DragonTigerList from '@/components/order/DragonTigerList'
import DragonTigerListV2 from '@/components/order/DragonTigerListV2'
import PerformanceDetail from '@/components/order/PerformanceDetail'
import StudyAdviserDragonTigerList from '@/components/order/StudyAdviserDragonTigerList'
import StudyAdviserPerformanceDetail from '@/components/order/StudyAdviserPerformanceDetail'
import FundUserBillList from '@/components/fund/FundUserBillList'
// 财务
import InvoiceList from '@/components/financial/InvoiceList'
import RefundList from '@/components/financial/RefundList'
import IncomeStatistics from '@/components/financial/IncomeStatistics'
import StudyAdviserRefundDashboard from '@/components/financial/StudyAdviserRefundDashboard'
// 系统管理
import AdminUserList from '@/components/admin/AdminUserList'
import StudyDutyList from '@/components/admin/StudyDutyList'
import LogList from '@/components/admin/LogList'
import MessageTemplate from '@/components/admin/MessageTemplate'
import MessageLog from '@/components/admin/MessageLog'
import AdminGroupList from '@/components/admin/AdminGroupList'
import AdminRuleList from '@/components/admin/AdminRuleList'
import AdminConfigList from '@/components/admin/AdminConfigList'
import AdminTConfigList from '@/components/admin/AdminTConfigList'
import SendSms from '@/components/admin/SendSms'
// 个人消息
import TrailLessonFailedReason from '@/components/message/TrailLessonFailedReason'
import TrailLessonFeedBack from '@/components/message/TrailLessonFeedBack'
import TrailLessonAbsentReason from '@/components/message/TrailLessonAbsentReason'
// 数据中心
import StudyAdviserTrack from '@/components/data/StudyAdviserTrack'
import ShowLessonCount from '@/components/data/ShowLessonCount'
import ShowAddLeaveNumDetail from '@/components/data/ShowAddLeaveNumDetail'
import ShowAddCourseDetail from '@/components/data/ShowAddCourseDetail'
import ShowTotalLeaveDetail from '@/components/data/ShowTotalLeaveDetail'
import TelDetails from '@/components/data/TelDetails'
import AdviserData from '@/components/data/AdviserData'
import ShowAssignDetail from '@/components/data/ShowAssignDetail'
import ShowAdviserDataDetail from '@/components/data/ShowAdviserDataDetail'
import PersonMessage from '@/components/message/PersonMessage'
import NegativeComment from '@/components/data/detail/NegativeComment'
import TchReviewDetail from '@/components/data/detail/TchReviewDetail'
import NewAssignDetail from '@/components/data/detail/NewAssignDetail'
import StudentAbsentDetail from '@/components/data/detail/StudentAbsentDetail'
import TchNoReviewDetail from '@/components/data/detail/TchNoReviewDetail'
import StudentEarlyDetail from '@/components/data/detail/StudentEarlyDetail'
import UserLeaveDetail from '@/components/data/detail/UserLeaveDetail'
import RenewDataList from '@/components/data/RenewDataList'
import FinishRenewalRateList from '@/components/data/FinishRenewalRateList'
import LessonExpendDailyList from '@/components/data/LessonExpendDailyList'
import StudentDailyList from '@/components/data/StudentDailyList'
import StatisticsGatherList from '@/components/data/StatisticsGatherList'
import SalesUtilizationLIst from '@/components/data/SalesUtilizationList'
import StudentLifeCycle from '@/components/data/StudentLifeCycle'
import StudyAdviserList from '@/components/data/StudyAdviserList'
import StudyAdviserConsumeList from '@/components/data/StudyAdviserConsumeList'
import FinanceDailyList from '@/components/data/FinanceDailyList'
import StudentContract from '@/components/data/StudentContract'
import TchContract from '@/components/data/TchContract'
// 应急管理
import TeacherPool from '@/components/emergency/TeacherPoolOriginal'

// 官网活动
import UserVideoList from '@/components/activity/UserVideoList'
import SafenessUserVideoList from '@/components/safenessVote/UserVideoList'
// 课程管理
import ClassinFolder from '@/components/course/ClassinFolder'
import ClassReview from '@/components/course/ClassReview'
import LessonPreviewList from '@/components/course/LessonPreviewList'
import LessonPreview from '@/components/course/LessonPreview'
import CoursePriceList from '@/components/course/CoursePriceList'
import ReplaceRecord from '@/components/lesson/ReplaceRecord'
import BindTeacherOperationRecord from '@/components/user/BindTeacherOperationRecord'
import BindGroupLessonScan from '@/components/user/BindGroupLessonScan'
import BindGroupLevel from '@/components/user/BindGroupLevel'
import BookMaterialLessonsErr from '@/components/course/BookMaterialLessonsErr'
import LessonVideoList from '@/components/course/LessonVideoList'
import LessonAudioList from '@/components/course/LessonAudioList'

// 题库
import AbilityList from '@/components/question/AbilityList'
import TestLevelQuestionList from '@/components/question/TestLevelQuestionList'
import TemplateList from '@/components/question/TemplateList'
import ContractVersion from '@/components/data/ContractVersion'
import TchComplaintList from '@/components/teacher/TchComplaintList'
import TchAttendanceList from '@/components/teacher/TchAttendanceList'
import TchAttendanceDetailList from '@/components/teacher/TchAttendanceDetailList'
// 个人中心
// 约课
const TimetableList = r => require.ensure([],
  () => r(require('@/components/lesson/TimetableList.vue')), 'levelQuestion')
const TimetableDetailList = r => require.ensure([],
  () => r(require('@/components/lesson/TimetableDetailList.vue')),
  'levelQuestion')

// 等级测试
const LevelGradeList = r => require.ensure([],
  () => r(require('@/components/level/LevelGradeList.vue')), 'level')
const AuditList = r => require.ensure([],
  () => r(require('@/components/level/AuditList.vue')), 'level')
const BindUnfreezeAuditList = r => require.ensure([],
  () => r(require('@/components/level/BindUnfreezeAuditList.vue')), 'level')
const LevelQuestionList = r => require.ensure([],
  () => r(require('@/components/level/LevelQuestionList.vue')), 'level')
const LevelRecordList = r => require.ensure([],
  () => r(require('@/components/level/LevelRecordList.vue')), 'level')
const ReviewRecord = r => require.ensure([],
  () => r(require('@/components/level/ReviewRecore.vue')), 'level')

const OpenClassList = r => require.ensure([],
  () => r(require('@/components/course/OpenClassList.vue')), 'course')
const BookLessonList = r => require.ensure([],
  () => r(require('@/components/course/BookLessonList.vue')), 'course')
const LessonSubjectList = r => require.ensure([],
  () => r(require('@/components/course/LessonSubjectList.vue')), 'course')
const MaterialLevelList = r => require.ensure([],
  () => r(require('@/components/course/MaterialLevelList.vue')), 'course')

const ClassInfoList = r => require.ensure([],
  () => r(require('@/components/support/ClassInfoList.vue')), 'support')

const SmsRecordList = r => require.ensure([],
  () => r(require('@/components/support/SmsRecordList.vue')), 'support')
const InternalMobileList = r => require.ensure([],
  () => r(require('@/components/support/InternalMobileList.vue')), 'support')
const IpBlacklistList = r => require.ensure([],
  () => r(require('@/components/support/IpBlacklistList.vue')), 'support')
const StudentTempLoginPassword = r => require.ensure([],
  () => r(require('@/components/support/StudentTempLoginPassword.vue')), 'support')
const DiplomaticRiskList = r => require.ensure([],
  () => r(require('@/components/support/DiplomaticRiskList.vue')), 'support')
const TotalClassInfoList = r => require.ensure([],
  () => r(require('@/components/support/TotalClassInfoList.vue')), 'support')

const Index = r => require.ensure([],
  () => r(require('@/components/Index.vue')), 'index')

const TeacherPerformanceList = r => require.ensure([],
  () => r(require('@/components/data/TeacherPerformanceList.vue')), 'data')
const TeacherSalaryList = r => require.ensure([],
  () => r(require('@/components/data/TeacherSalaryList.vue')), 'data')
const ForeignTeacherDeductionSummary = r => require.ensure([],
  () => r(require('@/components/data/ForeignTeacherDeductionSummary.vue')), 'data')
const TeacherMonthlyCoreData = r => require.ensure([],
  () => r(require('@/components/data/TeacherMonthlyCoreData.vue')), 'data')
const TeacherFilipinoSalaryList = r => require.ensure([],
  () => r(require('@/components/data/TeacherFilipinoSalaryList.vue')), 'data')
const TchClassList = r => require.ensure([],
  () => r(require('@/components/data/TchClassList.vue')), 'data')
const TchClassUsageList = r => require.ensure([],
  () => r(require('@/components/data/TchClassUsageList.vue')), 'data')
const TchNegativeList = r => require.ensure([],
  () => r(require('@/components/data/TchNegativeList.vue')), 'data')
const TchUsageList = r => require.ensure([],
  () => r(require('@/components/data/TchUsageList.vue')), 'data')

const SpeechVoiceList = r => require.ensure([],
  () => r(require('@/components/speech/SpeechVoiceList.vue')), 'speech')
const SpeechCompose = r => require.ensure([],
  () => r(require('@/components/speech/SpeechCompose.vue')), 'speech')
const SpeechClipList = r => require.ensure([],
  () => r(require('@/components/speech/SpeechClipList.vue')), 'speech')

export default [
  {
    path: '/',
    redirect: {path: '/user/userPayList'}
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/index',
        name: 'Index',
        component: Index
      },
      {
        path: '/market/exChangeRecordListB',
        name: 'exChangeRecordListB',
        component: ExChangeRecordListB,
        meta: {title: '兑换课程审核列表'}
      },
      {
        path: 'question/AbilityList',
        name: 'abilityList',
        component: AbilityList,
        meta: {title: '英语能力信息列表'}
      },
      {
        path: 'question/TemplateList',
        name: 'templateList',
        meta: {title: '题目模板管理'},
        component: TemplateList
      },
      {
        path: 'question/TestLevelQuestionList',
        name: 'testLevelQuestionList',
        meta: {title: '题目模板管理'},
        component: TestLevelQuestionList
      },
      {
        path: 'data/salesUtilizationList',
        name: 'salesUtilizationList',
        meta: {title: '销售名单利用统计'},
        component: SalesUtilizationLIst
      },
      {
        path: 'data/studentLifeCycle',
        name: 'studentLifeCycle',
        meta: {title: '学员生命周期'},
        component: StudentLifeCycle
      },
      {
        path: 'data/studyAdviserList',
        name: 'studyAdviserList',
        meta: {title: '后端学导数据'},
        component: StudyAdviserList
      },
      {
        path: 'data/studyAdviserConsumeList',
        name: 'studyAdviserConsumeList',
        meta: {title: '班主任课耗绩效'},
        component: StudyAdviserConsumeList
      },
      {
        path: '/market/activityList',
        name: 'activityList',
        meta: {title: '活动列表'},
        component: ActivityList
      },
      {
        path: '/market/channelManagement',
        name: 'channelManagement',
        meta: {title: '渠道管理'},
        component: ChannelManagement
      },
      {
        path: '/market/ChannelDealRate',
        name: 'channelDealRate',
        meta: {title: '渠道成交率'},
        component: ChannelDealRate
      },
      {
        path: '/market/ArticlePublishList',
        name: 'articlePublishList',
        meta: {title: '文章发布表'},
        component: ArticlePublishList
      },
      {
        path: '/market/ChannelIncludeList',
        name: 'channelIncludeList',
        meta: {title: '发布渠道收录表'},
        component: ChannelIncludeList
      },
      {
        path: '/market/AiChannelIncludeList',
        name: 'aiChannelIncludeList',
        meta: {title: 'AI渠道收录表'},
        component: AiChannelIncludeList
      },
      {
        path: '/market/shareManagement',
        name: 'shareManagement',
        meta: {title: '分享有礼海报管理'},
        component: ShareManagement
      },
      {
        path: '/agent/agentUserList',
        name: 'agentUserList',
        meta: {title: '代理用户'},
        component: AgentUserList
      },
      {
        path: '/agent/agentInviteList',
        name: 'agentInviteList',
        meta: {title: '推荐记录'},
        component: AgentInviteList
      },
      {
        path: '/crm/adviserPunchList',
        name: 'adviserPunchList',
        meta: {title: '打卡分单'},
        component: AdviserPunchList
      },
      {
        path: '/crm/dailyTransferList',
        name: 'dailyTransferList',
        meta: {title: '今日将转出名单'},
        component: DailyTransferList
      },
      {
        path: '/user/bookTestList',
        name: 'bookTestList',
        meta: {title: '体验名单'},
        component: BookTestList
      },
      {
        path: '/user/userExperienceList',
        name: 'userExperienceList',
        meta: {title: '体验学生'},
        component: UserExperienceList
      },
      {
        path: '/user/userPayList',
        name: 'userPayList',
        meta: {title: '常规学生列表'},
        component: UserPayList
      },
      {
        path: '/user/userTodayNewList',
        name: 'userTodayNewList',
        meta: {title: '新生分配'},
        component: UserPayList
      },
      {
        path: '/user/newStudentService',
        name: 'newStudentService',
        meta: {title: '学情反馈'},
        component: NewStudentService
      },
      {
        path: '/user/userPayDetail',
        name: 'userPayDetail',
        meta: {title: '学生信息详情'},
        component: UserPayDetail
      },
      {
        path: '/user/userProvisionalList',
        name: 'userProvisionalList',
        meta: {title: '待分配学生列表'},
        component: UserProvisionalList
      },
      {
        path: '/user/userTrackList',
        name: 'userTrackList',
        meta: {title: '学员跟踪记录'},
        component: UserTrackList
      },
      {
        path: '/user/studentRiskList',
        name: 'studentRiskList',
        meta: {title: '学员风险'},
        component: StudentRiskList
      },
      {
        path: '/user/tchRebindBoard',
        name: 'tchRebindBoard',
        meta: {title: '异动老师看板'},
        component: TchRebindBoard
      },
      {
        path: '/user/userTrackEdit',
        name: 'userTrackEdit',
        meta: {title: '添加学员跟踪记录'},
        component: UserTrackEdit
      },
      {
        path: '/user/personUserTrackList',
        name: 'personUserTrackList',
        meta: {title: '学员服务记录'},
        component: PersonUserTrackList
      },
      {
        path: '/user/parentCommunicationRecords',
        name: 'parentCommunicationRecords',
        meta: {title: '添加跟踪记录-家长沟通确认记录-学导'},
        component: ParentCommunicationRecords
      },
      {
        path: '/user/parentCommunicationAdviserRecords',
        name: 'parentCommunicationAdviserRecords',
        meta: {title: '添加跟踪记录-家长沟通确认记录-课顾'},
        component: ParentCommunicationAdviserRecords
      },
      {
        path: '/user/addOrderFailRecords',
        name: 'addOrderFailRecords',
        meta: {title: '添加跟踪记录-报名失败记录'},
        component: AddOrderFailRecords
      },
      {
        path: '/user/addSendMaterialRecords',
        name: 'addSendMaterialRecords',
        meta: {title: '添加跟踪记录-教材配送记录'},
        component: AddSendMaterialRecords
      },
      {
        path: '/user/bindingValidTimeFailRecords',
        name: 'bindingValidTimeFailRecords',
        meta: {title: '添加跟踪记录-绑定有效时间生效失败记录'},
        component: BindingValidTimeFailRecords
      },
      {
        path: '/user/bookUserLeaveTimeList',
        name: 'bookUserLeaveTimeList',
        meta: {title: '学生请假列表'},
        component: BookUserLeaveTimeList
      },
      {
        path: '/user/bookCourseChangeList',
        name: 'bookCourseChangeList',
        meta: {title: '补课时记录'},
        component: BookCourseChangeList
      },
      {
        path: '/user/editStudentInfo',
        name: 'editStudentInfo',
        meta: {title: '添加跟踪记录-试听课成功预约提醒记录'},
        component: EditStudentInfo
      },
      {
        path: '/user/activityExamineList',
        name: 'activityExamineList',
        meta: {title: '朋友圈分享审核列表'},
        component: ActivityExamineList
      },
      {
        path: '/user/exchangeRecordList',
        name: 'exchangeRecordList',
        meta: {title: '兑换记录'},
        component: ExchangeRecordList
      },
      {
        path: '/user/userRefundList',
        name: 'userRefundList',
        meta: {title: '退费学生列表'},
        component: UserRefundList
      },
      {
        path: '/user/userOverClassList',
        name: 'userOverClassList',
        meta: {title: '结课学生列表'},
        component: UserOverClassList
      },
      {
        path: '/user/userLessonsStopList',
        name: 'userLessonsStopList',
        meta: {title: '停课学生列表'},
        component: UserLessonsStopList
      },
      {
        path: '/user/userNotAllowedList',
        name: 'userNotAllowedList',
        meta: {title: '禁用学生列表'},
        component: UserNotAllowedList
      },
      {
        path: '/user/reviewClockRecordList',
        name: 'reviewClockRecordList',
        meta: {title: '打卡闯关记录'},
        component: ReviewClockRecordList
      },
      {
        path: '/bookMaterialLessons/DailyStudy',
        name: 'DailyStudy',
        meta: {title: '每日作业'},
        component: dailyStudy
      },
      {
        path: '/user/cancelLessonRecord',
        name: 'CancelLessonRecord',
        meta: {title: '取消课程记录'},
        component: CancelLessonRecord
      },
      {
        path: '/user/userStatusAuditList',
        name: 'userStatusAuditList',
        meta: {title: '学生状态审核'},
        component: UserStatusAuditList
      },
      {
        path: '/user/classHourFlow',
        name: 'classHourFlow',
        meta: {title: '课时流水'},
        component: ClassHourFlow
      },
      {
        path: '/user/distributionStudyRecord',
        name: 'distributionStudyRecord',
        meta: {title: '分配学导记录'},
        component: DistributionStudyRecord
      },
      {
        path: '/user/StudentWeekStatList',
        name: 'StudentWeekStatList',
        meta: {title: '周数据'},
        component: StudentWeekStatList
      },
      {
        path: '/user/StudentMonthStatList',
        name: 'StudentMonthStatList',
        meta: {title: '月数据'},
        component: StudentMonthStatList
      },
      {
        path: '/user/followUpList',
        name: 'followUpList',
        meta: {title: 'followUp记录'},
        component: FollowUpList
      },
      {
        path: '/user/wordCardList',
        name: 'wordCardList',
        meta: {title: '单词卡'},
        component: WordCardList
      },
      {
        path: '/speech/voice',
        name: 'speechVoice',
        meta: {title: '音色'},
        component: SpeechVoiceList
      },
      {
        path: '/speech/compose',
        name: 'speechCompose',
        meta: {title: '合成'},
        component: SpeechCompose
      },
      {
        path: '/speech/clip',
        name: 'speechClip',
        meta: {title: '成片'},
        component: SpeechClipList
      },
      {
        path: '/user/sentenceCardList',
        name: 'sentenceCardList',
        meta: {title: '句子翻译'},
        component: SentenceCardList
      },
      {
        path: '/user/studentWordbookList',
        name: 'studentWordbookList',
        meta: {title: '学生单词本'},
        component: StudentWordbookList
      },
      {
        path: '/user/studentWordcardEvalList',
        name: 'studentWordcardEvalList',
        meta: {title: '跟读记录'},
        component: StudentWordcardEvalList
      },
      {
        path: '/tch/trainingList',
        name: 'tchTrainingList',
        meta: {title: '培训中老师'},
        component: TchTrainingList
      },
      {
        path: '/tch/recruitTrainStat',
        name: 'tchRecruitTrainStat',
        meta: {title: '招聘培训统计'},
        component: TchRecruitTrainStat
      },
      {
        path: '/tch/recruit/dashboard',
        name: 'tchRecruitDashboard',
        meta: {title: '数据看板'},
        component: TchRecruitDashboard
      },
      {
        path: '/tch/recruit/leaderboard',
        name: 'tchRecruitLeaderboard',
        meta: {title: '招聘龙虎榜'},
        component: TchRecruitLeaderboard
      },
      {
        path: '/tch/recruit/pendingInterview',
        name: 'tchPendingInterview',
        meta: {title: '待面试老师'},
        component: TchPendingInterview
      },
      {
        path: '/tch/recruit/reserved',
        name: 'tchReservedList',
        meta: {title: '储备老师'},
        component: TchReservedList
      },
      {
        path: '/tch/regChannelList',
        name: 'tchRegChannelList',
        meta: {title: '注册渠道管理'},
        component: TchRegChannelList
      },
      {
        path: '/tch/tchNormalList',
        name: 'tchNormalList',
        meta: {title: '在职老师'},
        component: TchNormalList
      },
      {
        path: '/tch/tchUnauditedList',
        name: 'tchUnauditedList',
        meta: {title: '待审核老师'},
        component: TchUnauditedList
      },
      {
        path: '/tch/tchAuditList',
        name: 'tchAuditList',
        meta: {title: '已审核老师'},
        component: TchAuditList
      },
      {
        path: '/tch/tchFormalList',
        name: 'tchFormalList',
        meta: {title: '正式老师'},
        component: TchFormalList
      },
      {
        path: '/tch/foreignTchMatchCenter',
        name: 'foreignTchMatchCenter',
        meta: {title: '外教对接中心'},
        component: ForeignTchMatchCenter
      },
      {
        path: '/tch/filipino/tchFormalList',
        name: 'tchFilipinoFormalList',
        meta: {title: '正式老师(菲)'},
        component: TchFilipinoFormalList
      },
      {
        path: '/tch/tchResignFormalList',
        name: 'tchResignFormalList',
        meta: {title: '离职外教'},
        component: TchResignFormalList
      },
      {
        path: '/tch/tchAnomalyList',
        name: 'tchAnomalyList',
        meta: {title: '异动老师'},
        component: TchAnomalyList
      },
      {
        path: '/tch/tchLeaveList',
        name: 'tchLeaveList',
        meta: {title: '老师请假列表'},
        component: TchLeaveList
      },
      {
        path: '/tch/tchLeaveRateList',
        name: 'tchLeaveRateList',
        meta: {title: '在职老师请假率'},
        component: TchLeaveRateList
      },
      {
        path: '/tch/tchRiskWarningList',
        name: 'tchRiskWarningList',
        meta: {title: '外教异动风险监测'},
        component: TchRiskWarningList
      },
      {
        path: '/hrWorkbench/supervise',
        name: 'hrWorkbenchSupervise',
        meta: {title: '主管管理'},
        component: HrWorkbenchSupervise
      },
      {
        path: '/hrWorkbench/dashboard',
        name: 'hrWorkbenchDashboard',
        meta: {title: '工作台'},
        component: HrWorkbenchDashboard
      },
      {
        path: '/hrWorkbench/probation',
        name: 'hrWorkbenchProbation',
        meta: {title: '试用期到期提醒'},
        component: HrWorkbenchProbation
      },
      {
        path: '/hrWorkbench/review',
        name: 'hrWorkbenchReview',
        meta: {title: '新外教跟进'},
        component: HrWorkbenchReview
      },
      {
        path: '/hrWorkbench/contract',
        name: 'hrWorkbenchContract',
        meta: {title: '合同到期提醒'},
        component: HrWorkbenchContract
      },
      {
        path: '/hrWorkbench/followup',
        name: 'hrWorkbenchFollowup',
        meta: {title: '出勤风险跟进'},
        component: HrWorkbenchFollowup
      },
      {
        path: '/hrWorkbench/settings',
        name: 'hrWorkbenchSettings',
        meta: {title: '主管管理'},
        redirect: '/hrWorkbench/supervise'
      },
      {
        path: '/smartHr/roster',
        name: 'smartHrRoster',
        meta: {title: '花名册'},
        component: SmartHrRoster
      },
      {
        path: '/smartHr/onboarding',
        name: 'smartHrOnboarding',
        meta: {title: '入职管理'},
        component: SmartHrOnboarding
      },
      {
        path: '/smartHr/regularization',
        name: 'smartHrRegularization',
        meta: {title: '转正管理'},
        component: SmartHrRegularization
      },
      {
        path: '/smartHr/transfer',
        name: 'smartHrTransfer',
        meta: {title: '异动管理'},
        component: SmartHrTransfer
      },
      {
        path: '/smartHr/resignation',
        name: 'smartHrResignation',
        meta: {title: '离职管理'},
        component: SmartHrResignation
      },
      {
        path: '/smartHr/safety',
        name: 'smartHrSafety',
        meta: {title: '用工安全'},
        component: SmartHrSafety
      },
      {
        path: '/smartHr/growth',
        name: 'smartHrGrowth',
        meta: {title: '新人成长'},
        component: SmartHrGrowth
      },
      {
        path: '/smartHr/contract',
        name: 'smartHrContract',
        meta: {title: '合同管理'},
        component: SmartHrContract
      },
      {
        path: '/smartHr/retire',
        name: 'smartHrRetire',
        meta: {title: '退休管理'},
        component: SmartHrRetire
      },
      {
        path: '/smartHr/care',
        name: 'smartHrCare',
        meta: {title: '员工关怀'},
        component: SmartHrCare
      },
      {
        path: '/tchImpact/overview',
        name: 'tchImpactOverview',
        meta: {title: '影响总览'},
        component: TchImpactOverview
      },
      {
        path: '/tchImpact/change',
        name: 'tchImpactChange',
        meta: {title: '学生异动影响'},
        component: TchImpactChange
      },
      {
        path: '/tchImpact/leave',
        name: 'tchImpactLeave',
        meta: {title: '请假/旷课影响'},
        component: TchImpactLeave
      },
      {
        path: '/tchImpact/student',
        name: 'tchImpactStudent',
        meta: {title: '学生影响明细'},
        component: TchImpactStudent
      },
      {
        path: '/tchImpact/risk',
        name: 'tchImpactRisk',
        meta: {title: '综合风险视图'},
        component: TchImpactRisk
      },
      {
        path: '/tchImpact/model',
        name: 'tchImpactModel',
        meta: {title: '指标口径'},
        component: TchImpactModel
      },
      {
        path: '/tch/tchSignLogList',
        name: 'tchSignLogList',
        meta: {title: '老师签到日志'},
        component: TchSignLogList
      },
      {
        path: '/tch/tchSignTimeList',
        name: 'tchSignTimeList',
        meta: {title: '签到记录'},
        component: TchSignTimeList
      },
      {
        path: '/tch/tchOpenedExceptionList',
        name: 'TchOpenedExceptionList',
        meta: {title: '上课异常列表'},
        component: TchOpenedExceptionList
      },
      {
        path: '/tch/tchExceptionLogList',
        name: 'tchExceptionLogList',
        meta: {title: '异常操作日志'},
        component: TchExceptionLogList
      },
      {
        path: '/tch/messageCenter',
        name: 'teacherManagerMessage',
        meta: {title: '外管消息'},
        component: TeacherManagerMessage
      },
      {
        path: '/tch/learningMaterialList',
        name: 'tchLearningMaterialList',
        meta: {title: '外教中心展示资料'},
        component: TchLearningMaterialList
      },
      {
        path: '/tch/onboardingChecklist',
        name: 'tchOnboardingChecklist',
        meta: {title: '外教开课Checklist'},
        component: TchOnboardingList
      },
      {
        path: '/tch/onboardingManage',
        name: 'tchOnboardingManage',
        meta: {title: '开课Checklist管理'},
        component: TchOnboardingManage
      },
      {
        path: '/tch/tchRecommendList',
        name: 'tchRecommendList',
        meta: {title: '老师推荐记录'},
        component: TchRecommendList
      },
      {
        path: '/tch/referrerList',
        name: 'referrerList',
        meta: {title: '推荐官管理'},
        component: ReferrerList
      },
      {
        path: '/tch/referrerFeeList',
        name: 'referrerFeeList',
        meta: {title: '被推荐人管理'},
        component: ReferrerFeeList
      },
      {
        path: '/tch/tchComplaintList',
        name: 'tchComplaintList',
        meta: {title: '课堂投诉'},
        component: TchComplaintList
      },
      {
        path: '/tch/tchAttendanceList',
        name: 'tchAttendanceList',
        meta: {title: '老师考勤'},
        component: TchAttendanceList
      },
      {
        path: '/tch/tchAttendanceDetailList',
        name: 'tchAttendanceDetailList',
        meta: {title: '老师考勤明细'},
        component: TchAttendanceDetailList
      },
      {
        path: '/tch/tchTrackList',
        name: 'tchTrackList',
        meta: {title: '老师跟踪记录'},
        component: TchTrackList
      },
      {
        path: '/tch/tchWagesList',
        name: 'tchWagesList',
        meta: {title: '工资条管理'},
        component: TchWagesList
      },
      {
        path: '/tch/tchFeedbackList',
        name: 'tchFeedbackList',
        meta: {title: '老师反馈列表'},
        component: TchFeedbackList
      },
      {
        path: '/tch/tchPerformanceList',
        name: 'tchPerformanceList',
        meta: {title: '外管绩效'},
        component: TchPerformanceList
      },
      {
        path: '/tch/tchForeignManageData',
        name: 'tchForeignManageData',
        meta: {title: '外管数据'},
        component: TchForeignManageData
      },
      {
        path: '/tch/tchTeacherRanking',
        name: 'tchTeacherRanking',
        meta: {title: '优秀外教排行榜'},
        component: TchTeacherRanking
      },
      {
        path: '/tch/tchHrMetricsDashboard',
        name: 'tchHrMetricsDashboard',
        meta: {title: '外教核心数据看板'},
        component: TchHrMetricsDashboard
      },
      {
        path: '/tch/tchFirstCheckList',
        name: 'tchFirstCheckList',
        meta: {title: '外教首课签到'},
        component: TchFirstCheckList
      },
      {
        path: '/tch/trialLessonRequirements',
        name: 'trialLessonRequirements',
        meta: {title: '体验课上课要求'},
        component: TrialLessonRequirements
      },
      {
        path: '/lesson/timetableList',
        name: 'TimetableList',
        meta: {title: '色块排课表'},
        component: TimetableList
      },
      {
        path: '/lesson/timetableDetailList',
        name: 'TimetableDetailList',
        meta: {title: '色块排课表-老师'},
        component: TimetableDetailList
      },
      {
        path: '/lesson/bookLessonOpenedList',
        name: 'bookLessonOpenedList',
        meta: {title: '常规课程列表'},
        component: BookLessonOpenedList
      },
      {
        path: '/lesson/classFeedback',
        name: 'classFeedback',
        meta: {title: '课堂反馈'},
        component: ClassFeedback
      },
      {
        path: '/lesson/liveMonitor',
        name: 'liveMonitor',
        meta: {title: '实时监课'},
        component: LiveMonitor
      },
      {
        path: '/lesson/bookLessonTempList',
        name: 'bookLessonTempList',
        meta: {title: '当天订课信息'},
        component: BookLessonTempList
      },
      {
        path: '/lesson/bookLessonFinishedList',
        name: 'bookLessonFinishedList',
        meta: {title: '已结束课表'},
        component: BookLessonFinishedList
      },
      {
        path: '/lesson/bookClassinList',
        name: 'bookClassinList',
        meta: {title: 'ClassIn临时账号'},
        component: BookClassinList
      },
      {
        path: '/order/fundPackageList',
        name: 'fundPackageList',
        component: FundPackageList,
        meta: {title: '订单管理-订单列表'},
      },
      {
        path: '/order/performanceList',
        name: 'performanceList',
        meta: {title: '业绩统计'},
        component: PerformanceList
      },
      {
        path: '/order/dragonTigerList',
        name: 'dragonTigerList',
        meta: {title: '龙虎榜'},
        component: DragonTigerList
      },
      {
        path: '/order/dragonTigerListV2',
        name: 'dragonTigerListV2',
        meta: {title: '龙虎榜'},
        component: DragonTigerListV2
      },
      {
        path: '/order/performanceDetail',
        name: 'performanceDetail',
        meta: {title: '业绩详情'},
        component: PerformanceDetail
      },
      {
        path: '/order/studyAdviserDragonTiger',
        name: 'studyAdviserDragonTiger',
        meta: {title: '班主任龙虎榜'},
        component: StudyAdviserDragonTigerList
      },
      {
        path: '/order/studyAdviserPerformanceDetail',
        name: 'studyAdviserPerformanceDetail',
        meta: {title: '班主任业绩详情'},
        component: StudyAdviserPerformanceDetail
      },
      {
        path: '/fund/fundUserBillList',
        name: 'fundUserBillList',
        meta: {title: '用户账单'},
        component: FundUserBillList
      },
      {
        path: '/mex/comp/questions',
        name: 'mexCompQuestionList',
        meta: {title: '综合题库'},
        component: MexCompQuestionList
      },
      {
        path: '/mex/speak/questions',
        name: 'mexSpeakQuestionList',
        meta: {title: '口语题库'},
        component: MexSpeakQuestionList
      },
      {
        path: '/mex/blueprints',
        name: 'mexBlueprintList',
        meta: {title: '蓝图'},
        component: MexBlueprintList
      },
      {
        path: '/mex/trial',
        name: 'mexTrialPaper',
        meta: {title: '试做试卷'},
        component: MexTrialPaper
      },
      {
        path: '/mex/sessions',
        name: 'mexSessionList',
        meta: {title: '场次记录'},
        component: MexSessionList
      },
      {
        path: '/mex/feedback',
        name: 'mexFeedbackList',
        meta: {title: '题目反馈'},
        component: MexFeedbackList
      },
      {
        path: '/mex/promotions',
        name: 'mexPromotionList',
        meta: {title: '升班建议'},
        component: MexPromotionList
      },
      {
        path: '/mex/advice',
        name: 'mexAdviceList',
        meta: {title: '学习建议'},
        component: MexAdviceList
      },
      {
        path: '/mex/stats',
        name: 'mexItemStatsList',
        meta: {title: '实测统计'},
        component: MexItemStatsList
      },
      {
        path: '/mex/cohorts',
        name: 'mexScoreCohortList',
        meta: {title: '同龄分群'},
        component: MexScoreCohortList
      },
      {
        path: '/mex/gray',
        name: 'mexGraySetting',
        meta: {title: '灰度设置'},
        component: MexGraySetting
      },
      {
        path: '/adminUser/adminUserList',
        name: 'adminUserList',
        meta: {title: '管理员列表'},
        component: AdminUserList
      },
      {
        path: '/adminUser/StudyDutyList',
        name: 'studyDutyList',
        meta: {title: '班主任值班表'},
        component: StudyDutyList
      },
      {
        path: '/adminUser/LogList',
        name: 'logList',
        meta: {title: '操作日志'},
        component: LogList
      },
      {
        path: '/adminUser/MessageTemplate',
        name: 'messageTemplate',
        meta: {title: '消息模板'},
        component: MessageTemplate
      },
      {
        path: '/adminUser/MessageLog',
        name: 'messageLog',
        meta: {title: '消息日志'},
        component: MessageLog
      },
      {
        path: '/adminGroup/adminGroupList',
        name: 'adminGroupList',
        meta: {title: '权限组管理'},
        component: AdminGroupList
      },
      {
        path: '/adminGroup/adminRuleList',
        name: 'adminRuleList',
        meta: {title: '权限菜单列表'},
        component: AdminRuleList
      },
      {
        path: '/admin/adminConfigList',
        name: 'adminConfigList',
        meta: {title: '新增父级类目'},
        component: AdminConfigList
      },
      {
        path: '/admin/adminTConfigList',
        name: 'adminTConfigList',
        meta: {title: '自动排课配置管理'},
        component: AdminTConfigList
      },
      {
        path: '/admin/sendSms',
        name: 'sendSms',
        meta: {title: '短信发送'},
        component: SendSms
      },
      {
        path: '/auditList',
        name: 'AuditList',
        meta: {title: '修改绑定审批'},
        component: AuditList
      },
      {
        path: '/bindUnfreezeAuditList',
        name: 'BindUnfreezeAuditList',
        meta: {title: '修改绑定解冻'},
        component: BindUnfreezeAuditList
      },
      {
        path: '/level/levelGradeList',
        name: 'LevelGradeList',
        meta: {title: '等级列表'},
        component: LevelGradeList
      },
      {
        path: '/level/levelQuestionList',
        name: 'LevelQuestionList',
        meta: {title: '测试题列表'},
        component: LevelQuestionList
      },
      {
        path: '/level/levelRecordList',
        name: 'LevelRecordList',
        meta: {title: '测试结果'},
        component: LevelRecordList
      },
      {
        path: '/level/reviewRecore',
        name: 'ReviewRecord',
        meta: {title: '测试记录'},
        component: ReviewRecord
      },
      {
        path: '/course/openClassList',
        name: 'OpenClassList',
        meta: {title: '公开课列表'},
        component: OpenClassList
      },
      {
        path: '/course/bookLessonList',
        name: 'BookLessonList',
        meta: {title: '单节课列表'},
        component: BookLessonList
      },
      {
        path: '/course/materialLevelList',
        name: 'MaterialLevelList',
        meta: {title: '等级列表'},
        component: MaterialLevelList
      },
      {
        path: '/course/classinFolder',
        name: 'ClassinFolder',
        meta: {title: 'Classin文件目录'},
        component: ClassinFolder
      },
      {
        path: '/course/coursePriceList',
        name: 'coursePriceList',
        meta: {title: '教材价格列表'},
        component: CoursePriceList
      },
      {
        path: '/course/lessonPreviewList',
        name: 'lessonPreviewList',
        meta: {title: '课前预习'},
        component: LessonPreviewList
      },
      {
        path: '/course/LessonVideoList',
        name: 'lessonVideoList',
        meta: {title: '课后视频'},
        component: LessonVideoList
      },
      {
        path: '/course/LessonAudioList',
        name: 'lessonAudioList',
        meta: {title: '课程音频'},
        component: LessonAudioList
      },
      {
        path: '/course/classReview',
        name: 'classReview',
        meta: {title: '课后习题'},
        component: ClassReview
      },
      {
        path: '/course/lessonSubject',
        name: 'lessonSubject',
        meta: {title: '课前课后题目'},
        component: LessonSubjectList
      },
      {
        path: '/course/BookMaterialLessonsErr',
        name: 'BookMaterialLessonsErr',
        meta: {title: '教材报错'},
        component: BookMaterialLessonsErr
      },
      {
        path: '/support/totalClassInfoList',
        name: 'totalClassInfoList',
        meta: {title: '总课时充值对照'},
        component: TotalClassInfoList
      },
      {
        path: '/support/classInfoList',
        name: 'classInfoList',
        meta: {title: '课程对照'},
        component: ClassInfoList
      },
      {
        path: '/support/internalMobile',
        name: 'internalMobile',
        meta: {title: '内部手机号'},
        component: InternalMobileList
      },
      {
        path: '/support/ipBlacklist',
        name: 'ipBlacklist',
        meta: {title: 'IP黑名单'},
        component: IpBlacklistList
      },
      {
        path: '/support/studentTempLoginPassword',
        name: 'studentTempLoginPassword',
        meta: {title: '学生临时登录密码'},
        component: StudentTempLoginPassword
      },
      {
        path: '/support/diplomaticRisk',
        name: 'diplomaticRisk',
        meta: {title: '外教风险地区'},
        component: DiplomaticRiskList
      },
      {
        path: '/sms/recordList',
        name: 'smsRecordList',
        meta: {title: '短信电话记录'},
        component: SmsRecordList
      },
      {
        path: '/data/tchClassList',
        name: 'tchClassList',
        meta: {title: '老师薪酬统计'},
        component: TchClassList
      },
      {
        path: '/data/teacherPerformanceList',
        name: 'teacherPerformanceList',
        meta: {title: '老师绩效统计'},
        component: TeacherPerformanceList
      },
      {
        path: '/data/teacherSalaryList',
        name: 'teacherSalaryList',
        meta: {title: '老师薪酬统计'},
        component: TeacherSalaryList
      },
      {
        path: '/data/foreignTeacherDeductionSummary',
        name: 'foreignTeacherDeductionSummary',
        meta: {title: '外教课上课统计'},
        component: ForeignTeacherDeductionSummary
      },
      {
        path: '/data/teacherMonthlyCoreData',
        name: 'teacherMonthlyCoreData',
        meta: {title: '外教月度核心数据'},
        component: TeacherMonthlyCoreData
      },
      {
        path: '/data/filipino/teacherSalaryList',
        name: 'teacherFilipinoSalaryList',
        meta: {title: '老师薪酬统计(菲)'},
        component: TeacherFilipinoSalaryList
      },
      {
        path: '/data/tchNegativeList',
        name: 'tchNegativeList',
        meta: {title: '老师投诉列表'},
        component: TchNegativeList
      },
      {
        path: '/data/showAdviserDataDetail',
        name: 'showAdviserDataDetail',
        meta: {title: '课顾汇总数据详情'},
        component: ShowAdviserDataDetail
      },
      {
        path: '/data/tchClassUsageList',
        name: 'tchClassUsageList',
        meta: {title: '老师数据统计'},
        component: TchClassUsageList
      },
      {
        path: '/data/tchUsageList',
        name: 'tchUsageList',
        meta: {title: '老师使用率'},
        component: TchUsageList
      },
      {
        path: '/data/studyAdviserTrack',
        name: 'studyAdviserTrack',
        meta: {title: '学导跟进数据'},
        component: StudyAdviserTrack
      },
      {
        path: '/data/showLessonCount',
        name: 'showLessonCount',
        meta: {title: '课程消耗数据'},
        component: ShowLessonCount
      },
      {
        path: '/data/showAddLeaveNumDetail',
        name: 'showAddLeaveNumDetail',
        meta: {title: '学导申请请假记录'},
        component: ShowAddLeaveNumDetail
      },
      {
        path: '/data/showAddCourseDetail',
        name: 'showAddCourseDetail',
        meta: {title: '学导申请加课时记录'},
        component: ShowAddCourseDetail
      },
      {
        path: '/data/showAssignDetail',
        name: 'showAssignDetail',
        meta: {title: '分配名单详情'},
        component: ShowAssignDetail
      },
      {
        path: '/data/showTotalLeaveDetail',
        name: 'showTotalLeaveDetail',
        meta: {title: '学生请假详情'},
        component: ShowTotalLeaveDetail
      },
      {
        path: '/data/telDetails',
        name: 'telDetails',
        meta: {title: '电话沟通详情'},
        component: TelDetails
      },
      {
        path: '/data/adviserData',
        name: 'adviserData',
        meta: {title: '课程顾问跟进数据'},
        component: AdviserData
      },
      {
        path: '/data/negativeComment',
        name: 'negativeComment',
        meta: {title: '差评投诉列表'},
        component: NegativeComment
      },
      {
        path: '/data/tchReviewDetail',
        name: 'tchReviewDetail',
        meta: {title: '评价超时列表'},
        component: TchReviewDetail
      },
      {
        path: '/data/newAssignDetail',
        name: 'newAssignDetail',
        meta: {title: '新签学生列表'},
        component: NewAssignDetail
      },
      {
        path: '/data/studentEarlyDetail',
        name: 'studentEarlyDetail',
        meta: {title: '学生早退详情'},
        component: StudentEarlyDetail
      },
      {
        path: '/data/userLeaveDetail',
        name: 'userLeaveDetail',
        meta: {title: '学生常规请假详情'},
        component: UserLeaveDetail
      },
      {
        path: '/data/subsidyLeaveDetail',
        name: 'subsidyLeaveDetail',
        meta: {title: '两小时内常规课学生请假详情'},
        component: UserLeaveDetail,
        props: { listUrl: '/bc/listSubsidyLeaveDetail' }
      },
      {
        path: '/data/studentAbsentDetail',
        name: 'studentAbsentDetail',
        meta: {title: '上课异常列表'},
        component: StudentAbsentDetail
      },
      {
        path: '/data/tchNoReviewDetail',
        name: 'tchNoReviewDetail',
        meta: {title: '老师未评论列表'},
        component: TchNoReviewDetail
      },
      {
        path: '/data/RenewDataList',
        name: 'RenewDataList',
        meta: {title: '续费数据列表'},
        component: RenewDataList
      },
      {
        path: '/activity/UserVideoList',
        name: 'UserVideoList',
        meta: {title: '学生作品管理'},
        component: UserVideoList
      },
      {
        path: '/safenessVote/UserVideoList',
        name: 'SafenessUserVideoList',
        meta: {title: '学生作品管理'},
        component: SafenessUserVideoList
      },
      {
        path: '/emergency/teacherPool',
        name: 'TeacherPool',
        meta: {title: '应急外教池管理'},
        component: TeacherPool
      },
      {
        path: '/emergency/trialTeacherPool',
        name: 'TrialTeacherPool',
        meta: {title: '试听外教池'},
        component: TeacherPool
      },
      {
        path: '/message/personMessage',
        name: 'personMessage',
        meta: {title: '个人邮箱'},
        component: PersonMessage
      },
      {
        path: '/message/trailLessonFailedReason',
        name: 'trailLessonFailedReason',
        meta: {title: '试听课预约失败记录'},
        component: TrailLessonFailedReason
      },
      {
        path: '/message/trailLessonFeedBack',
        name: 'trailLessonFeedBack',
        meta: {title: '试听课后反馈记录'},
        component: TrailLessonFeedBack
      },
      {
        path: '/message/trailLessonAbsentReason',
        name: 'trailLessonAbsentReason',
        meta: {title: '试听课预缺席记录'},
        component: TrailLessonAbsentReason
      },
      {
        path: '/crm/MyResource',
        name: 'myResource',
        meta: {title: '个人资源'},
        component: MyResource
      },
      {
        path: '/crm/TreasuryResource',
        name: 'treasuryResource',
        meta: {title: '公共资源'},
        component: TreasuryResource
      },
      {
        path: '/crm/SpellGroupList',
        name: 'spellGroupList',
        meta: {title: '拼团记录'},
        component: SpellGroupList
      },
      {
        path: '/crm/DistributionList',
        name: 'distributionList',
        meta: {title: '分配记录'},
        component: DistributionList
      },
      {
        path: '/crm/SalesDealRate',
        name: 'salesDealRate',
        meta: {title: '销售成交率'},
        component: SalesDealRate
      },
      {
        path: '/crm/FirstFollowList',
        name: 'firstFollowList',
        meta: {title: '首次跟踪记录'},
        component: FirstFollowList
      },
      {
        path: '/crm/PhoneRecordList',
        name: 'phoneRecordList',
        meta: {title: '销售通话记录'},
        component: PhoneRecordList
      },
      {
        path: '/crm/DviAudioList',
        name: 'dviAudioList',
        meta: {title: '销售通话记录AI'},
        component: DviAudioList
      },
      {
        path: '/crm/CallAsrWord',
        name: 'callAsrWord',
        meta: {title: '通话转写词表'},
        component: CallAsrWord
      },
      {
        path: '/crm/CallScript',
        name: 'callScript',
        meta: {title: '销售话术库'},
        component: CallScript
      },
      {
        path: '/financial/InvoiceList',
        name: 'invoiceList',
        meta: {title: '应开发票'},
        component: InvoiceList
      },
      {
        path: '/financial/refundList',
        name: 'refundList',
        meta: {title: '退费列表'},
        component: RefundList
      },
      {
        path: '/financial/studyAdviserRefundDashboard',
        name: 'studyAdviserRefundDashboard',
        meta: {title: '班主任退费看板'},
        component: StudyAdviserRefundDashboard
      },
      {
        path: '/financial/IncomeStatistics',
        name: 'incomeStatistics',
        meta: {title: '收入统计'},
        component: IncomeStatistics
      },
      {
        path: '/tch/bonusAndDeductionList',
        name: 'BonusAndDeduction',
        meta: {title: '奖惩机制'},
        component: BonusAndDeduction
      },
      {
        path: '/lesson/ReplaceRecord',
        name: 'replaceRecord',
        meta: {title: '老师替换课记录'},
        component: ReplaceRecord
      },
      {
        path: '/user/BindTeacherOperationRecord',
        name: 'bindTeacherOperationRecord',
        meta: {title: '绑定老师记录'},
        component: BindTeacherOperationRecord
      },
      {
        path: '/user/bindGroupLessonScan',
        name: 'bindGroupLessonScan',
        meta: {title: '绑定分组课件修复'},
        component: BindGroupLessonScan
      },
      {
        path: '/user/bindGroupLevel',
        name: 'bindGroupLevel',
        meta: {title: '多级别绑定等级'},
        component: BindGroupLevel
      },
      {
        path: '/data/lessonExpendDailyList',
        name: 'lessonExpendDailyList',
        meta: {title: '课程消耗日报列表'},
        component: LessonExpendDailyList
      },
      {
        path: '/data/studentDailyList',
        name: 'studentDailyList',
        meta: {title: '学生量统计列表'},
        component: StudentDailyList
      },
      {
        path: '/data/finishRenewalRateList',
        name: 'finishRenewalRateList',
        meta: {title: '常规生转化率列表'},
        component: FinishRenewalRateList
      },
      {
        path: '/data/statisticsGatherList',
        name: 'statisticsGatherList',
        meta: {title: '数据汇总列表'},
        component: StatisticsGatherList
      },
      {
        path: '/data/financeDaily',
        name: 'financeDailyList',
        meta: {title: '财务每日数据'},
        component: FinanceDailyList
      },
      {
        path: '/student-contract',
        name: 'studentContract',
        meta: {title: '学生合同'},
        component: StudentContract
      },
      {
        path: '/tch-contract',
        name: 'tchContract',
        meta: {title: '老师合同'},
        component: TchContract
      },
      {
        path: '/data/contract-version',
        name: 'contractVersion',
        meta: {title: '合同模板'},
        component: ContractVersion
      },
      {
        path: '/disk/index',
        name: 'diskIndex',
        meta: {title: '网盘'},
        component: DiskIndex
      },
      {
        path: '/disk/recycle',
        name: 'diskRecycle',
        meta: {title: '回收站'},
        component: DiskIndex
      },
      {
        path: '/disk/shares',
        name: 'diskShares',
        meta: {title: '分享记录'},
        component: DiskShareRecords
      },
      {
        path: '/kb/index',
        name: 'kbIndex',
        meta: {title: '库管理'},
        component: KbIndex
      }
    ]
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/loginSms',
    name: 'LoginSms',
    component: LoginSms
  },
  {
    path: '/disk/share',
    name: 'diskShare',
    meta: {title: '网盘分享'},
    component: DiskShare
  },
  {
    path: '/order/userCredential2',
    name: 'userCredential2',
    meta: {title: '课程购买凭据'},
    component: UserCredential2
  },
  {
    path: '/order/userCredential',
    name: 'userCredential',
    meta: {title: '課程購買憑據'},
    component: UserCredential
  },
  {
    path: '/course/lessonPreview',
    name: 'lessonPreview',
    component: LessonPreview
  },
]



// WEBPACK FOOTER //
// ./src/router/index.js